<h1 mat-dialog-title>
  Der findes allerede et {{ data.opgaveText | lowercase }} inden for 48 timer
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <p>
    {{data.opgaveText}} oprettet {{ data.oprettid | date: "dd.MM.yyyy" }} med
    deadline {{ data.deadline | date: "dd.MM.yyyy" }}
  </p>
  <p *ngIf="data.note">
    Note: {{ data.note }}
  </p>
  <p>
    Vil du fortsætte?
  </p>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Fortryd</button>
  <button mat-raised-button [mat-dialog-close]="data">Opret tilkald</button>
</div>
